import { HttpClient } from '@angular/common/http';
import BigNumber from 'bignumber.js';
import { tap } from 'rxjs/operators';
import { Base } from '../base';

export class UserRounds extends Base {
  constructor(protected httpClient: HttpClient, private parent: string) {
    super(httpClient, `${parent}/user_rounds`);
  }

  getCurrent(account: string) {
    account = account.toLocaleLowerCase();
    return this.api.get('current', {
      account
    }).pipe(
      tap((json) => this.processRecord(json.userRound))
    )
  }

  private processRecord(record: any) {
    record.subscription = new BigNumber(record.subscription).fromDecimal();
    record.redemption = new BigNumber(record.redemption).fromDecimal();
  }
}
